import React, { useContext } from "react";
import { Link } from "react-router-dom";
// Icons
import { AuthContext } from "../../helpers/AuthContext";
import { isAdministratorRole } from "../../utils/instanceRoleInheritance";
import MessageIcon from '@mui/icons-material/Message';
import SubjectIcon from '@mui/icons-material/Subject';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';

function MyInstancesLeftSidebar() {
  const { authState } = useContext(AuthContext);
  return (
    // <div className="leftSide">
    <div className="leftSide my-instances-sidebar">
    <div className="ec-instance-core-nav">

        <div className="list-item">
          <a href="https://elitecore.ca" target="_blank">
            <span className="list-item-icon ec-home-website-icon"><LanguageOutlinedIcon /></span><span className="list-item-text">Elite Core<br />Website</span>
          </a>
        </div>

        {/* PromoWorld Resources remains temporarily hidden. */}

        {isAdministratorRole(authState?.role) ? (
  <>      
    <div className="list-heading">ACTIONS</div>

    <div className="list-item">
      <Link to="/">
        <span className="list-item-icon"><SubjectIcon/></span>
        <span className="list-item-text">My cores</span>
      </Link>
    </div>

    <div className="list-item">
      <Link to="/new-instance">
        <span className="list-item-icon"><MessageIcon/></span>
        <span className="list-item-text">Create core</span>
      </Link>
      {/*<Link to="/invoices" className="disabled-link">
        <span className="list-item-icon"><MonetizationOnIcon/></span>
        <span className="list-item-text">Invoices</span>
        </Link>*/}
      {/*<Link to={"/profile/" + authState.id + "/payment-methods"} className="disabled-link">
        <span className="list-item-icon"><CreditCardIcon/></span>
        <span className="list-item-text">Payment methods</span>
      </Link>*/}
    </div>
  </>
) : ""}

      </div>
    </div>

  );
}

export default MyInstancesLeftSidebar;
